/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCurrentPricesRequest} from '@cash-web/protos/squareup/cash/marketprices/service.pb'
import {GetCurrentPricesResponse} from '@cash-web/protos/squareup/cash/marketprices/service.pb'


export const getCurrentPrices = (request:GetCurrentPricesRequest, options?: CashRequestOptions) => post<GetCurrentPricesRequest, GetCurrentPricesResponse>("/2.0/cash/investing/get-current-prices", request, {...options, rejectOnError: true })